// extracted by mini-css-extract-plugin
module.exports = {"GeneralFooter":"GeneralFooter___2Vzxx"};